module.exports = __webpack_public_path__ + "img/bg02.be319f12.jpg";